import React from "react";

type Props = {
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
};

export const IntegerField: React.FC<Props> = ({
  value,
  onChange,
  disabled,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const inputValue = e.target.value;

    // Allow empty string
    if (inputValue === "") {
      onChange(null);
      return;
    }

    // Only allow integers (no decimal points)
    if (/^-?\d+$/.test(inputValue)) {
      onChange(parseInt(inputValue, 10));
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    // Prevent decimal point, 'e', 'E', '+' from being entered
    if ([".", "e", "E", "+"].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      value={value !== null && value !== undefined ? String(value) : ""}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md
        focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-transparent
        disabled:tw-bg-gray-100 disabled:tw-cursor-not-allowed"
    />
  );
};
